import { LOAD_USER, LOAD_USER_SUCCESS, LOAD_USER_ERROR } from "../actions/user";

export default ({ user_id }) => (dispatch, getState) => {
  dispatch({ type: LOAD_USER });
  return fetch(`${process.env.REACT_APP_USERDATA_URI}/user/${user_id}`)
    .then(res => res.json())
    .then(payload => {
      if (!payload) throw new Error("No user found");
      return payload;
    })
    .then(payload => dispatch({ type: LOAD_USER_SUCCESS, payload }))
    .catch(({ message: payload }) =>
      dispatch({ type: LOAD_USER_ERROR, payload })
    );
};



// WEBPACK FOOTER //
// ./src/store/epics/loadUserData.js